import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const PROJECT_MEMBERS_CHANGED_EVENT_TOKEN = new InjectionToken<Observable<any>>('Project members change notifier');
